export const SINGLE_META_GET = 'SINGLE_META_GET';
export const SINGLE_META_GET_FAILURE = 'SINGLE_META_GET_FAILURE';

export const SINGLE_META_GET_ALL = 'SINGLE_META_GET_ALL';
export const SINGLE_META_GET_ALL_FAILURE = 'SINGLE_META_GET_ALL_FAILURE';

export const SINGLE_META_GET_DATA_IS_LOADING = 'SINGLE_META_GET_DATA_IS_LOADING';

export const SINGLE_META_RESET_SEARCH = 'SINGLE_META_RESET_SEARCH';
